'use client';
import { createContext, useContext } from 'react';
const uploadProgressContext = createContext(null);
uploadProgressContext.displayName = 'UploadProgressContext';
export const getUploadProgressContext = () => uploadProgressContext;
export const useUploadProgressContext = () => {
    const context = useContext(getUploadProgressContext());
    if (!context) {
        throw new Error('useUploadProgress must be used within an UploadProgressProvider');
    }
    return context;
};
//# sourceMappingURL=uploadProgressContext.js.map